<template>
  <div v-if="show">
  </div>
</template>
<script>
import MethodService from '../../../service/MethodService'
export default {
  data() {
    return {
      show: false,
      currentUser: MethodService.getCurrentUser(),
      listFeatures: MethodService.getListFeatures(),
      companyInfo: MethodService.getCompanyInfo(),
      employeeInfo: MethodService.getEmployeeInfo()
    }
  },
  methods: {
    checkToRoute () {
      if (!this.employeeInfo) {
        if (this.currentUser.id == this.companyInfo.id) this.progressFunction()
      } else {
        if ( this.currentUser.id == this.employeeInfo.id ) this.progressFunction()
      }
    },
    progressFunction() {
      let route = MethodService.getNavSubMenus()
      if (route && route.length > 0) {
        if (
          route[0].children &&
          route[0].children.length > 0 &&
          route[0].children[0].nameRoute
        ) {
          this.$router.push({ name: route[0].children[0].nameRoute })
        } else if (route[0].nameRoute) {
          this.$router.push({ name: route[0].nameRoute })
        }
      } else {
        if (
          this.employeeInfo &&
          this.employeeInfo.administrative_info &&
          this.employeeInfo.administrative_info.name &&
          this.employeeInfo.administrative_info.name.full_name
        ) {
          this.fullName = this.employeeInfo.administrative_info.name.full_name
          setTimeout(() => {
            this.show = true
          }, 1000)
        }
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.checkToRoute()
    }, 1000 * 1)
  }
}
</script>
